import { z } from "zod"

import { calculatedCostItemSchema } from "./calculated-cost-item"
import { calculatedCostSummarySchema } from "./calculated-cost-summary"
import { propertyDataSchema } from "./property-data"

/**
 * https://www.switchsolar.io/api-reference/account-api/account-cost-calculation/#calculated-cost
 */
export const calculatedCostSchema = z.object({
  /**
   * Unique Genability ID for the master tariff of this calculation’s tariff.
   */
  masterTariffId: z.number(),
  /**
   * The name of this tariff.
   */
  tariffName: z.string(),
  /**
   * Total summed up cost of all cost items (see below).
   */
  totalCost: z.number(),
  /**
   * The start date and time of this calculation.
   */
  fromDateTime: z.string(),
  /**
   * The end date and time of this calculation.
   */
  toDateTime: z.string(),
  /**
   * A decimal value between 0 and 1 representing the
   * accuracy of the calculation.
   */
  accuracy: z.number(),
  /**
   * The currency represented in the calculation.
   */
  currency: z.string(),
  /**
   *  Unique identifier for this calculation.
   */
  calculatedCostId: z.string().optional().nullable(),
  /**
   * Summary of cost and resource totals.
   */
  summary: calculatedCostSummarySchema,
  /**
   * Breakdown of the summary data with variable granularity and grouping.
   */
  items: z.array(calculatedCostItemSchema),
  /**
   * The properties, modeling assumptions, and other key
   * info used in the calculation.
   */
  assumptions: z.array(propertyDataSchema),
})

export type CalculatedCost = z.infer<typeof calculatedCostSchema>
